
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire48bd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire48bd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
//src\js\cases.jquery.js

var $aaQnt = parcelRequire("aaQnt");
// Функция для проверки ширины экрана
function $4547521531010008$var$isMobileWidth() {
    return window.matchMedia('(max-width: 765px)').matches;
}
if ($4547521531010008$var$isMobileWidth()) {
    (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(document).ready(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.case-card-module').each(function() {
            const $module = (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(this);
            const $containers = $module.find('> .card-image-container');
            const $caseDescriptionContainers = $module.find('.case-description-container');
            $caseDescriptionContainers.addClass('is-hidden'); // Скрываем все описания при загрузке страницы
            $containers.on('click', function() {
                const $container = (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(this);
                const $caseDescriptionContainer = $container.find('.case-description-container');
                // Если контейнер уже широкий, переключаем показ/скрытие описания
                if ($container.hasClass('wide-image')) {
                    $caseDescriptionContainer.toggleClass('is-hidden');
                    return;
                }
                // Если контейнер узкий, делаем его широким
                if ($container.hasClass('narrow-image')) {
                    const $wideContainer = $containers.filter('.wide-image');
                    const $narrowContainers = $containers.not($wideContainer).not($container);
                    $wideContainer.removeClass('wide-image').addClass('narrow-image');
                    $container.removeClass('narrow-image').addClass('wide-image');
                    $container.prependTo($module);
                    $caseDescriptionContainer.removeClass('is-hidden');
                    $caseDescriptionContainers.not($caseDescriptionContainer).addClass('is-hidden');
                    reorderContainers($module, $containers);
                }
            });
        });
    });
    function reorderContainers($module, $containers) {
        const $wideContainer = $containers.filter('.wide-image');
        const $narrowContainers = $containers.not($wideContainer);
        $narrowContainers.detach();
        $wideContainer.appendTo($module);
        $narrowContainers.prependTo($module);
    }
}


//# sourceMappingURL=cases.78789134.js.map
